/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import { SALESFORCE_CHECK } from '../view/ViewActions';

export const REQUESTED_API_KEY = 'REQUESTED_API_KEY';
export const RECEIVED_API_KEY = 'RECEIVED_API_KEY';
export const ERROR_API_KEY = 'ERROR_API_KEY';
export const EXPIRE_VENDOR_SESSION = 'EXPIRE_VENDOR_SESSION';
export const ADD_VENDOR_SESSION = 'ADD_VENDOR_SESSION';

export const requestedApiKey = () => {
  return {
    type: REQUESTED_API_KEY,
    payload: true
  };
};

export const receivedApiKey = (apiKey) => {
  return {
    type: RECEIVED_API_KEY,
    apiKey
  };
};

export const errorApiKey = (error) => {
  return {
    type: ERROR_API_KEY,
    error
  };
};

export const REQUESTED_ON_PREMISE_SESSION = 'REQUESTED_ON_PREMISE_SESSION';
export const RECEIVED_ON_PREMISE_SESSION = 'RECEIVED_ON_PREMISE_SESSION';
export const ERROR_ON_PREMISE_SESSION = 'ERROR_ON_PREMISE_SESSION';

export const requestedOnPremiseSession = () => {
  return {
    type: REQUESTED_ON_PREMISE_SESSION,
    payload: true
  };
};

export const receivedOnPremiseSession = (sessionData) => {
  return {
    type: RECEIVED_ON_PREMISE_SESSION,
    sessionData
  };
};

export const errorOnPremiseSession = (error) => {
  return {
    type: ERROR_ON_PREMISE_SESSION,
    error
  };
};

export const REQUESTED_USER_AUTHENTICATION = 'REQUESTED_USER_AUTHENTICATION';
export const RECEIVED_USER_AUTHENTICATION = 'RECEIVED_USER_AUTHENTICATION';
export const REQUESTED_USER_ENTITLEMENTS = 'REQUESTED_USER_ENTITLEMENTS';
export const RECEIVED_USER_ENTITLEMENTS = 'RECEIVED_USER_ENTITLEMENTS';

export const requestedUserAuthentication = () => {
  return {
    type: REQUESTED_USER_AUTHENTICATION,
    payload: true
  };
};

export const receivedUserAuthentication = (userId, entitlements) => {
  return {
    type: RECEIVED_USER_AUTHENTICATION,
    userId,
    entitlements
  };
};

export const requestedUserEntitlements = () => {
  return {
    type: REQUESTED_USER_ENTITLEMENTS,
    payload: true
  };
};

export const receivedUserEntitlements = (userId, entitlements) => {
  return {
    type: RECEIVED_USER_ENTITLEMENTS,
    userId,
    entitlements
  };
};

export const ERROR_USER_AUTHENTICATION = 'ERROR_USER_AUTHENTICATION';
export const errorUserAuthentication = (error) => {
  return {
    type: ERROR_USER_AUTHENTICATION,
    error
  };
};

export const STORE_QUERY_PARAMS = 'STORE_QUERY_PARAMS';

export const storeQueryParams = (pairs) => {
  let params = {};
  pairs.forEach((pair) => {
    const keyValueArray = Object.entries(pair)[0];
    const param = { [keyValueArray[0]]: keyValueArray[1] };

    params = {
      ...params,
      ...param
    };
  });
  return {
    type: STORE_QUERY_PARAMS,
    params
  };
};

export const SET_APP_ENTRYPOINT = 'SET_APP_ENTRYPOINT';
export const setAppEntryPoint = (page) => {
  return {
    type: SET_APP_ENTRYPOINT,
    page
  };
};

export const setSalesforceRepEnabled = (action) => {
  return {
    type: SALESFORCE_CHECK,
    action
  };
};

export const expireVendorSession = (vendorName) => {
  return {
    type: EXPIRE_VENDOR_SESSION,
    vendorName
  };
};

export const initializeVendorSession = (vendorSession) => {
  return {
    type: ADD_VENDOR_SESSION,
    vendorSession
  };
};
